import { render, staticRenderFns } from "./tasksToday3.vue?vue&type=template&id=4ca477a6&"
import script from "./tasksToday3.vue?vue&type=script&lang=js&"
export * from "./tasksToday3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports